import { imageFieldsFrag } from '@/service/fragments/imageFieldsFrag'
import { gql } from '@/service/gql'
import { playableEntityFrag } from '@/service/fragments/playableEntityFrag'
import type { ResultOf } from 'gql.tada'

// language=GraphQL
export const artistFieldsFrag = gql(
    `
        fragment artistFields on Artist @_unmask {
            ...playableEntity,
            id
            name
            url
            images {
                ...imageFields
            }
            followsContext @include(if: $isAuthenticated) {
                isFollowed
            }
        }
    `,
    [imageFieldsFrag, playableEntityFrag]
)

export type ArtistFields = ResultOf<typeof artistFieldsFrag>
